import { Checkbox } from "antd";
import { useState } from "react";
import { toast } from "../../lib/toast";
import { underscoreToCapitalizeString } from "../../utils/utils";
import ConfirmModal from "../ui/ConfirmModal";

type Props = {
  open: boolean;
  columnList: string[];
  handleSubmit: (val: string[]) => void;
  handleClose: () => void;
};

export default function ColumnListModal({
  open,
  columnList,
  handleSubmit,
  handleClose,
}: Props) {
  const [selected, setSelected] = useState<string[]>(columnList);

  const list = columnList.map((col) => ({
    label: underscoreToCapitalizeString(col),
    value: col,
  }));

  const allSelected = selected.length === columnList.length;

  const handleSelectAllChange = (e: any) => {
    if (e.target.checked) {
      setSelected(columnList);
    } else {
      setSelected([]);
    }
  };

  const onSubmit = () => {
    if (!selected.length) {
      toast("error", "Please select column");
      return;
    }

    handleSubmit(selected);
  };

  return (
    <ConfirmModal
      open={open}
      handleOk={onSubmit}
      handleClose={handleClose}
      title="Column List"
      hideAlert
      okText="Submit"
      okButtonProps={{
        className: "!rounded !min-w-[110px]",
      }}
      cancelButtonProps={{
        className: "cancel-btn !min-w-[110px]",
      }}
      width={700}
      closable
    >
      <label
        htmlFor="all"
        className="flex items-center gap-2 mb-3 select-none cursor-pointer text-sm text-header font-medium"
      >
        <Checkbox
          id="all"
          checked={allSelected}
          onChange={handleSelectAllChange}
        />
        Select All
      </label>

      <div className="p-2.5 border-2 border-light border-dashed">
        <Checkbox.Group
          className="grid sm:grid-cols-2 md:grid-cols-3 items-center gap-x-1 gap-y-1.5"
          options={list}
          value={selected}
          onChange={(val) => setSelected(val as string[])}
        />
      </div>
    </ConfirmModal>
  );
}
